import {
  READ_FORMATDI_VARIABLES,
  LOAD_FORMATDI_VARIABLES,
  RESET_FORMATDI_VARIABLES
} from "types/Types";;

export const readFormatDIAction = () => ({ type: READ_FORMATDI_VARIABLES });
export const loadFormatDIAction = (data) => ({ type: LOAD_FORMATDI_VARIABLES, payload: data }); 
export const resetFormatDIAction = () => ({ type: RESET_FORMATDI_VARIABLES });
